import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {setCreateButton, setSearchHandler, setSearchString, setTitle} from "../actions/main";
import FormGroup from "../components/FormGroup";
import {InputNumber} from "primereact/inputnumber";
import formater from "../helpers/formater";

// Калькулятор % артиста: раздел фактических продаж между артистом и клубом (как в Excel заказчика).
// Прибыль = продажи − налог − комиссия билетного оператора − РАО (в варианте «С РАО»);
// артист = прибыль × % артиста, клуб = остаток.

const DEFAULTS = {tax: 11, commission: 6, rao: 5, artist: 70}

const loadParams = () => {
    try {
        return {...DEFAULTS, ...JSON.parse(localStorage.getItem('calc_split_params') || '{}')}
    } catch (e) {
        return DEFAULTS
    }
}

function CalcSplit() {
    const dispatch = useDispatch()
    const [sales, setSales] = useState(null)
    const [p, setP] = useState(loadParams)
    const [raoSales, setRaoSales] = useState(null)

    useEffect(() => {
        dispatch(setTitle('Калькулятор % артиста'))
        dispatch(setCreateButton(false))
        dispatch(setSearchString(''))
        dispatch(setSearchHandler(false))
    }, [dispatch])

    useEffect(() => {
        try { localStorage.setItem('calc_split_params', JSON.stringify(p)) } catch (e) {}
    }, [p])

    const setParam = (k, v) => setP((old) => ({...old, [k]: v === null || v === undefined ? 0 : v}))

    const calc = (withRao) => {
        const s = sales || 0
        const tax = s * p.tax / 100
        const commission = s * p.commission / 100
        const rao = withRao ? s * p.rao / 100 : 0
        const profit = s - tax - commission - rao
        const artist = profit * p.artist / 100
        return {s, tax, commission, rao, profit, artist, club: profit - artist}
    }
    const a = calc(true)
    const b = calc(false)
    const clubPct = 100 - (p.artist || 0)
    const money = (v) => formater.amountFormat(v || 0)
    const yellow = {background: '#fff7c2'}

    const Row = ({label, k, strong, style}) => (
        <tr style={style}>
            <td>{label}</td>
            <td style={{textAlign: 'right'}}>{strong ? <strong>{money(a[k])}</strong> : money(a[k])}</td>
            <td style={{textAlign: 'right'}}>{k === 'rao' ? <span style={{color: '#aaa'}}>—</span> : (strong ? <strong>{money(b[k])}</strong> : money(b[k]))}</td>
        </tr>
    )

    return (
        <>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-auto">
                            <FormGroup label={'Фактические продажи'}>
                                <InputNumber value={sales} mode={'currency'} currency={'RUB'} locale={'ru-RU'}
                                             onChange={(e) => setSales(e.value)} placeholder={'0 ₽'}/>
                            </FormGroup>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-auto">
                            <FormGroup label={'Налог, %'}>
                                <InputNumber value={p.tax} onChange={(e) => setParam('tax', e.value)} suffix={' %'}
                                             minFractionDigits={0} maxFractionDigits={2} min={0} max={100} inputStyle={{width: 110}}/>
                            </FormGroup>
                        </div>
                        <div className="col-auto">
                            <FormGroup label={'Комиссия оператора, %'}>
                                <InputNumber value={p.commission} onChange={(e) => setParam('commission', e.value)} suffix={' %'}
                                             minFractionDigits={0} maxFractionDigits={2} min={0} max={100} inputStyle={{width: 110}}/>
                            </FormGroup>
                        </div>
                        <div className="col-auto">
                            <FormGroup label={'РАО, %'}>
                                <InputNumber value={p.rao} onChange={(e) => setParam('rao', e.value)} suffix={' %'}
                                             minFractionDigits={0} maxFractionDigits={2} min={0} max={100} inputStyle={{width: 110}}/>
                            </FormGroup>
                        </div>
                        <div className="col-auto">
                            <FormGroup label={'Доля артиста, %'}>
                                <InputNumber value={p.artist} onChange={(e) => setParam('artist', e.value)} suffix={' %'}
                                             minFractionDigits={0} maxFractionDigits={2} min={0} max={100} inputStyle={{width: 110}}/>
                            </FormGroup>
                        </div>
                        <div className="col-auto" style={{alignSelf: 'flex-end', paddingBottom: 18}}>
                            <a href="/calc-artist" onClick={(e) => { e.preventDefault(); setP(DEFAULTS) }}>сбросить проценты</a>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-auto">
                            <table className={'table'} style={{minWidth: 520}}>
                                <thead>
                                <tr>
                                    <th></th>
                                    <th style={{textAlign: 'right'}}>С РАО</th>
                                    <th style={{textAlign: 'right'}}>БЕЗ РАО</th>
                                </tr>
                                </thead>
                                <tbody>
                                <Row label={'Фактические продажи'} k={'s'}/>
                                <Row label={`Налог ${p.tax}%`} k={'tax'}/>
                                <Row label={`Комиссия билетного оператора ${p.commission}%`} k={'commission'}/>
                                <Row label={`РАО ${p.rao}%`} k={'rao'} style={yellow}/>
                                <Row label={'Прибыль'} k={'profit'} strong/>
                                <Row label={`Артист ${p.artist}%`} k={'artist'} strong/>
                                <Row label={`Клуб ${clubPct}%`} k={'club'} strong/>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card mt-3">
                <div className="card-body">
                    <h5>РАО от фактических продаж</h5>
                    <div className="row">
                        <div className="col-auto">
                            <FormGroup label={'Фактические продажи'}>
                                <InputNumber value={raoSales} mode={'currency'} currency={'RUB'} locale={'ru-RU'}
                                             onChange={(e) => setRaoSales(e.value)} placeholder={'0 ₽'}/>
                            </FormGroup>
                        </div>
                        <div className="col-auto" style={{alignSelf: 'flex-end', paddingBottom: 18}}>
                            <span style={{...yellow, padding: '6px 10px'}}>
                                РАО {p.rao}%: <strong>{money((raoSales || 0) * p.rao / 100)}</strong>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CalcSplit
